/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Dialog_CloseInputs */

const en_layout_dialog_close = /** @type {(inputs: Layout_Dialog_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pl_layout_dialog_close = /** @type {(inputs: Layout_Dialog_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Layout_Dialog_CloseInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_dialog_close = /** @type {((inputs?: Layout_Dialog_CloseInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Dialog_CloseInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_dialog_close(inputs)
	return en_layout_dialog_close(inputs)
});